module.exports = __webpack_public_path__ + "img/money-back-7.e6f31afb.png";